<template>
  <div id="help-privacy-policy" class="h-100 space-about">
    <VuePerfectScrollbar
      class="custom-scroll-help-privacy-policy"
      :settings="settings"
      ref="helpPrivacyPolicyPS"
      :suppressScrollX="true"
    >
      <PrivacyPolicyPt v-if="displayComponentPt"></PrivacyPolicyPt>
      <PrivacyPolicyEn v-if="displayComponentEn"></PrivacyPolicyEn>
      <PrivacyPolicyEs v-if="displayComponentEs"></PrivacyPolicyEs>
    </VuePerfectScrollbar>
    <!-- <template v-if="!contentPrivate.url && contentPrivate.text" class="privacy-frame">
      <iframe width="100%" height="100%" frameborder="no" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" :srcdoc="contentPrivate.text" class="privacyPolicy"></iframe>
    </template>
    <template v-if="contentPrivate.url">
      <iframe :src="contentPrivate.url" width="100%" height="100%" frameborder="no" sandbox="allow-same-origin allow-scripts allow-popups allow-forms" class="ifr-policy"></iframe>
    </template> -->
    <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
  </div>
</template>

<script>
import { getLocaleCode } from '../../../helpers/locale-helper';
import contentService from '../../../providers/contentService';
import newsHomeService from '../../../providers/newsHomeService';
import PrivacyPolicyPt from './PrivacyPolicyPt.vue';
import PrivacyPolicyEn from './PrivacyPolicyEn.vue';
import PrivacyPolicyEs from './PrivacyPolicyEs.vue';
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated;
    },
  },
  components: {
    VuePerfectScrollbar,
    PrivacyPolicyPt,
    PrivacyPolicyEn,
    PrivacyPolicyEs
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true
      },
      contentPrivate: {},
      displayComponentPt: false,
      displayComponentEn: false,
      displayComponentEs: false,
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    },
  },
  created() {
    // this.fetchContent();
    const locale = this.$i18n.locale;
    const code = getLocaleCode(locale);
    switch (code) {
      case 1:
        this.displayComponentPt = true;
        break;
      case 2:
        this.displayComponentEn = true;
        break;
      case 3:
        this.displayComponentEs = true;
        break;
      case 4:
        this.displayComponentEs = true;
        break;
      case 5:
        this.displayComponentPt = true;
        break;
      default:
        this.displayComponentPt = true;
    }
  },
  mounted() {
    try {
      const backgroundDiv = document.createElement('div');
      backgroundDiv.className = 'popup-custom-background';
      document.getElementsByClassName('privacy-policy-modal')[0].appendChild(backgroundDiv);
    } catch (error) {}
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    fetchContent() {
      if (this.isAuthenticated) {
        contentService.getPrivacyPolicyCustom(new URLSearchParams())
        .then(resp => this.contentPrivate = resp)
        .catch(err => console.log(err))
      } else {
        newsHomeService.getContentPrivatePrivacyPolicy(new URLSearchParams())
        .then(resp => this.contentPrivate = resp)
        .catch(err => console.log(err))
      }
    }
  }
};
</script>

<style lang="scss">
#help-privacy-policy {
  height: 100%;
  padding-bottom: 35px;

  .custom-scroll-help-privacy-policy {
    height: 100%;
    width: 100%;
    // padding: 20px;
    background-color: #FFF;
    border-radius: 3px;
  }

  iframe {

  }
}
.mobile #help-privacy-policy .custom-scroll-help-privacy-policy {
  height: 90%;
}

ul.li-item {
    padding: 10px;
    list-style: decimal-leading-zero;
}
ul.li-item li{
    margin-bottom: 10px;
}
</style>
